webpackJsonp([182648443805807],{

/***/ 746:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(8);
	
	var _FleetBreadcrum = __webpack_require__(31);
	
	var _FleetBreadcrum2 = _interopRequireDefault(_FleetBreadcrum);
	
	var _Fleet = __webpack_require__(20);
	
	var _Fleet2 = _interopRequireDefault(_Fleet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//Components
	var PremiumEliteEn = function PremiumEliteEn(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'page  Premium' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: ' Premium Vehicles for Rent | Budget Nicaragua',
	      meta: [{
	        name: 'description',
	        content: 'Frequently Asked Questions about car rentals. '
	      }],
	      link: [{
	        rel: 'alternate',
	        hreflang: 'en',
	        href: './es/fleet/premium_elite'
	      }]
	    }),
	    _react2.default.createElement(_FleetBreadcrum2.default, {
	      lang: props.pathContext.langKey,
	      currentPage: ' Premium Cars'
	    }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      ' Premium Elite'
	    ),
	    _react2.default.createElement(_Fleet2.default, {
	      lang: props.pathContext.langKey,
	      types: props.data.dataJson.fleetTypes,
	      fleet: props.data.dataJson.fleet,
	      features: props.data.dataJson.fleetFeatures,
	      category: 8
	    })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = PremiumEliteEn;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-fleet-premium-elite-en-js-0cda2c3757090e3408da.js